<template>
  <div class="question-body" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <!-- 菜单 -->
    <websiteMenu :themeColor="themeColor"></websiteMenu>
    <!-- 视频底图 -->
    <video class="ticket-video" x5-playsinline="true" playsinline="true" webkit-playsinline="true"
      x-webkit-airplay="true" x5-video-orientation="portraint" autoplay muted loop style="object-fit: cover;"
      poster="https://pdsite.partydaysport.com/official_website/buyTickets/ticket-video-poster2.png">
      <source src="https://pdsite.partydaysport.com/official_website/buyTickets/ticket-bg.mp4" type="video/mp4" />
    </video>
    <div class="question-box">
      <!-- 返回按钮 -->
      <!-- <div class="dialog-back">
        <el-button size="mini" type="primary" @click="goBack">
          <div>返回</div>
          <div>Return</div>
        </el-button>
      </div> -->
      <!-- 标题 -->
      <img class="title" src="https://pdsite.partydaysport.com/official_website/buyTickets/ticket-title.png">
      <!-- 标签页 -->
      <div class="tabs-box flex">
        <el-button size="mini" type="primary" :plain="currentTabIndex == 1 ? false : true" @click="changeTabIndex(1)">
          <div>可使用</div>
          <div>Available</div>
        </el-button>
        <el-button size="mini" type="primary" :plain="currentTabIndex == 2 ? false : true" @click="changeTabIndex(2)">
          <div>已失效</div>
          <div>Expired</div>
        </el-button>
      </div>
      <!-- 门票内容 -->
      <div class="ticket-list">
        <!-- 没数据显示 -->
        <div class="nodata-tip" v-if="!ticketList.length">
          <div class="en">您的帳戶未綁定任何票</div>
          <div class="cn">Your account has not been linked to any tickets</div>
        </div>
        <!-- 门票列表 -->
        <div class="ticket-content" v-else>
          <div class="ticket-box" v-for="(item, index) in ticketList" :key="index">
            <div class="ticket-right">
              <img class="image" :src="item.image">
              <div class="ticket-top">
                <!-- 标题 -->
                <div class="title">{{ item.title }}</div>
                <!-- 出票时间 -->
                <div class="time" v-if="currentTabIndex == 2">出票時間：{{ item.printing }}</div>
                <!-- 活动时间 -->
                <div class="time" v-if="item.activityStartTime">活動時間：{{ item.activityStartTime }}</div>
                <!-- 预约人 -->
                <div class="time" v-if="item.name">預約姓名：{{ item.name }}</div>
                <!-- 押金 -->
                <div class="time" v-if="item.money_type">押金：{{ item.money }}</div>
              </div>
            </div>
            <!-- 功能按钮 -->
            <div class="action-btn flex" v-if="currentTabIndex == 1">
              <el-dropdown trigger="click" v-if="item.activity_status === 1">
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <!-- activity_status == 2过期了 -->
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-date" v-if="item.activity_status === 1"
                    @click.native="rescheduleTicket(item)">預約改期</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- 占位 -->
              <div v-else></div>
              <div class="flex">
                <el-button size="mini" type="primary" plain
                  v-if="item.type == 1 && !item.money_type && item.activity_status == 1 && item.name"
                  @click="payDeposit(item.id)">
                  <div>押金支付</div>
                  <div>Deposit Payment</div>
                </el-button>
                <el-button size="mini" type="primary" v-if="!item.name" @click="identityBind(item)">
                  <div>身份綁定</div>
                  <div>Identity Binding</div>
                </el-button>
                <el-button size="mini" type="primary" v-if="item.activity_status == 1 && !item.status && item.name"
                  @click="isShowTicketQrcode(item.identifier)">
                  <div>門票二維碼</div>
                  <div>Ticket QR code</div>
                </el-button>
                <el-button size="mini" type="primary" v-if="!item.activity_status" @click="appointmentTicket(item)">
                  <div>場次選擇</div>
                  <div>Ticket QR code</div>
                </el-button>
              </div>
            </div>
          </div>
          <div class="nodata-tip">-到底啦-</div>
        </div>
      </div>
      <!-- 购买按钮 -->
      <div class="dialog-footer">
        <el-button type="primary" @click="toRedeem">
          <div class="cn">立即兌換</div>
          <div class="en">Redeem now</div>
        </el-button>
        <el-button type="primary" @click="toBuy">
          <h1>
            <div class="cn">立即購買</div>
            <div class="en">BUY NOW</div>
          </h1>
        </el-button>
      </div>
    </div>
    <!-- 购票人管理弹窗 -->
    <div class="popup-content" v-if="isPopupUser" @click="cancelPopupUser">
      <div class="popup-box popup-user" @click.stop>
        <!-- 添加购票人 -->
        <div class="add-user" @click="handleAdd">
          <i class="el-icon-circle-plus-outline"></i>
          <span>Please add user</span>
        </div>
        <!-- 购票人列表 -->
        <div class="user-list">
          <div class="user-singel" v-for="(item, index) in userList" :key="index">
            <div class="user-info">
              <div class="user-tag name">{{ item.name }}</div>
              <div class="user-tag phone">{{ item.mobile.slice(0, 3) }}****{{ item.mobile.slice(7) }}
              </div>
              <div class="user-tag card">{{ item.identifierNumber.slice(0, 6) }}********{{
                item.identifierNumber.slice(14) }}</div>
            </div>
            <div class="action-btn">
              <div class="btn" @click="addUserForTicket(item)">選擇</div>
              <div class="btn" @click="updateUserForTicket(item.id)">修改</div>
              <div class="btn" @click="removeUserForTicket(item)">删除</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加或修改用户信息对话框 -->
    <el-dialog class="add-user-dialog" :title="title" :visible.sync="open" append-to-body :close-on-click-modal="false">
      <el-form ref="formUser" :model="formUser" :rules="rulesUser" label-width="80px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="formUser.name" placeholder="Please Enter Full Name" />
        </el-form-item>
        <el-form-item label="手機號" prop="mobile">
          <el-input v-model="formUser.mobile" placeholder="Please Enter Mobile Phone Number" />
        </el-form-item>
        <el-form-item label="證件類型" prop="identifierType">
          <el-select style="width: 100%;" v-model="formUser.identifierType"
            placeholder="Please Select The Type Of Identification Document" clearable filterable>
            <el-option v-for="dict in typeOptions" :key="dict.value" :label="dict.label" :value="dict.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="證件號碼" prop="identifierNumber">
          <el-input v-model="formUser.identifierNumber" placeholder="Please Enter Your Identification Number" />
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="formUser.sex">
            <el-radio v-for="dict in sexOptions" :key="dict.value" :label="dict.value" :aria-hidden="false">{{
              dict.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="生日" prop="birthday">
          <el-date-picker style="width: 100%;" v-model="formUser.birthday" type="date" value-format="yyyy-MM-dd"
            placeholder="Please Select A Date">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="user-footer">
        <el-button type="primary" @click="submitForm">確定</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
      </div>
    </el-dialog>
    <!-- 二维码门票查看弹窗 -->
    <div class="popup-pay-content" v-if="isPopupTicketCode" @click="isPopupTicketCode = false">
      <div class="popup-box" @click.stop>
        <div id="qrcodeView" ref="qrcodeView"></div>
      </div>
    </div>
    <!-- 支付二维码弹窗 -->
    <div class="popup-content" v-if="isPopupPay" @click="cancelPopupPay">
      <div class="popup-box qrcode-box" @click.stop>
        <img class="title" src="@/assets/images/yajintitle.png">
        <div id="qrcode" ref="qrcode"></div>
        <div class="qrcode-text">
          <div>Please use WeChat/Alipay to scan the code</div>
          <div>請使用微信/支付寶掃碼</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
import {
  getUserTicket,
  payTicketDeposit,
  getYaOrderStatus
} from "@/api/index";
import {
  addBuyer,
  editBuyer,
  delBuyer,
  listBuyer,
  detailsBuyer,
  setupBuyerv3,
} from "@/api/activity";
import websiteMenu from '@/components/website-menu.vue'
export default {
  components: {
    websiteMenu
  },
  data() {
    return {
      ticketList: [],//门票列表
      currentTabIndex: 1,//标签页下标
      loading: false, // 加载状态
      isPopupTicketCode: false,//门票码弹窗
      themeColor: "white", // 菜单主题颜色
      formUser: {},
      // 表单校验
      rulesUser: {
        name: [{ required: true, message: "Please Enter Full Name", trigger: "blur" }],
        mobile: [{ required: true, message: "Please Enter Mobile Phone Number", trigger: "blur" }],
        identifierType: [{ required: true, message: "Please Select The Type Of Identification Document", trigger: "change" }],
        identifierNumber: [{ required: true, message: "Please Enter Your Identification Numbe", trigger: "blur" }],
        sex: [{ required: true, message: "Please Select Gender", trigger: "change" }],
        birthday: [{ required: true, message: "Please Select A Date", trigger: "blur" }],
      },
      typeOptions: [{
        label: "身份證",
        value: '01'
      }, {
        label: "護照",
        value: '02'
      }, {
        label: "軍人證",
        value: '03'
      }, {
        label: "駕照",
        value: '04'
      }, {
        label: "港澳回鄉證",
        value: '05'
      }, {
        label: "臺胞證",
        value: '07'
      }],//证件类型
      sexOptions: [{
        label: "男",
        value: 1
      }, {
        label: "女",
        value: 2
      }],//性别
      isPopupUser: false,//购票人信息弹窗
      open: false,
      title: "",
      userList: [],//购票人信息
      currentIdentifier: "",//当前门票号
      isPopupPay: false,//支付二维码弹窗
      statusTimeout: null,//1秒倒计时
      isPaySuccess: false,//是否支付成功
    };
  },
  mounted() {
    this.gueryUserTicketList()

    // 兑换后的提醒
    if (this.$route.query.status == 'redeem') {
      this.$alert('門票兌換成功，快去進行場次預約吧~', '場次預約', {
        confirmButtonText: '確定',
        callback: action => {
          this.$router.replace('/myTicket')
        }
      });
    }

    // 支付后的提醒
    if (this.$route.query.status == 'buy') {
      this.$alert('可在我的門票頁面進行查看，如有時間變動，點擊更多可進行預約改期哦~', '支付成功', {
        confirmButtonText: '確定',
        callback: action => {
          this.$router.replace('/myTicket')
        }
      });
    }
  },
  beforeDestroy() {
    if (this.statusTimeout) {
      clearInterval(this.statusTimeout);
      this.statusTimeout = null;
    }
  },
  methods: {
    // 返回
    goBack() {
      // 缓存语言
      var storageLang = localStorage.getItem('language');
      if (storageLang) {
        if (storageLang == 'cn') {
          window.location.href = "/cn/index.html";
        } else if (storageLang == 'en') {
          window.location.href = "/en/index.html";
        } else if (storageLang == 'tc') {
          window.location.href = "/tc/index.html";
        }
        return
      }
      // 浏览器语言
      var lang = navigator.language || navigator.userLanguage;
      if (lang.startsWith("zh")) {
        window.location.href = "/cn/index.html";
      } else {
        window.location.href = "/en/index.html";
      }
    },
    // 点击标签页切换门票状态
    changeTabIndex(index) {
      if (this.currentTabIndex != index) {
        this.currentTabIndex = index
        this.gueryUserTicketList()
      }
    },
    // 获取门票列表
    gueryUserTicketList() {
      this.loading = true
      this.ticketList = []
      getUserTicket({
        status: this.currentTabIndex - 1
      })
        .then((res) => {
          if (res.data.code == 200) {
            this.ticketList = res.data.data
          } else {
            if (res.data.code == 405) {
              this.$message({
                message: '帳號過期請重新登入',
                type: 'error'
              });
              localStorage.removeItem('satoken')
              this.$router.replace('/')
            } else {
              this.$message({
                message: res.data.message,
                type: 'error'
              });
            }
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 跳转购买界面
    toBuy() {
      this.$router.push('/buy')
    },
    // 跳转立即兑换页面
    toRedeem() {
      this.$router.push('/redeem')
    },
    // 判断场次类型
    getShowingsGroupId(time) {
      let currrentShowingsGroupId = null
      if (time === 120) {
        currrentShowingsGroupId = 1
      } else if (time === 240) {
        currrentShowingsGroupId = 2
      } else if (time === 0) {
        currrentShowingsGroupId = 3
      }
      return currrentShowingsGroupId
    },
    // 改约
    rescheduleTicket(item) {
      this.$router.push({
        path: '/buy',
        query: {
          storeId: item.store_id,//门店
          ticketIdentifier: item.identifier,//门票号
          currrentShowingsGroupId: this.getShowingsGroupId(item.time)//场次类型
        }
      });
    },
    // 预约时间
    appointmentTicket(item) {
      this.$router.push({
        path: '/buy',
        query: {
          storeId: item.store_id,//门店
          ticketId: item.ticket_id,//票id
          ticketIdentifier: item.identifier,//门票号
          currrentShowingsGroupId: this.getShowingsGroupId(item.time)//场次类型
        }
      });
    },
    // 显示门票二维码
    isShowTicketQrcode(url) {
      this.isPopupTicketCode = true
      this.$nextTick(() => {
        this.$refs.qrcodeView.innerHTML = "";
      });
      this.$nextTick(() => {
        this.qrcodeWechat("qrcodeView", 250, 250, url, "canvas");
      });
    },
    // 二维码生成
    qrcodeWechat(name, qWidth, qHeight, qText, qRender) {
      new QRCode(name, {
        width: qWidth,
        height: qHeight,
        text: qText,
        render: qRender,
      });
    },
    // 账户过期处理
    message405(res) {
      if (res.data.code == 405) {
        this.$notify({
          title: '帳號過期請重新登入',
          type: 'error'
        });
        localStorage.removeItem('satoken')
        this.$router.replace('/')
      } else {
        this.$notify({
          title: res.data.message || res.data.msg,
          type: 'error'
        });
      }
    },
    // 身份绑定
    identityBind(item) {
      this.currentIdentifier = item.identifier
      this.isPopupUser = true
      this.getList()
    },
    // 关闭购票人弹窗
    cancelPopupUser() {
      this.currentIdentifier = ""
      this.isPopupUser = false
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.resetUser();
    },
    // 表单重置
    resetUser() {
      this.formUser = {
        id: undefined,
        name: undefined,
        mobile: undefined,
        identifierType: undefined,
        identifierNumber: undefined,
        sex: undefined,
        birthday: undefined,
      };
      this.resetForm("formUser");
    },
    resetForm(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
      }
    },
    // 购票人列表
    getList() {
      listBuyer()
        .then((res) => {
          if (res.data.code == 200) {
            this.userList = res.data.data
          } else {
            this.message405(res)
          }
        })
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.resetUser();
      this.open = true;
      this.title = "添加購票人資訊";
    },
    /** 修改按钮操作 */
    updateUserForTicket(id) {
      this.resetUser();
      detailsBuyer({
        id
      }).then(res => {
        this.formUser = res.data.data;
      });
      this.open = true;
      this.title = "修改購票人資訊";
    },
    // 选择购票人
    addUserForTicket(item) {
      setupBuyerv3({
        buyerId: item.id,
        ticketIdentifier: this.currentIdentifier
      }).then(res => {
        if (res.data.code == 200) {
          this.$notify({
            title: '購票人添加成功',
            type: 'success',
            duration: 1000
          });
          this.gueryUserTicketList()
          this.cancelPopupUser()
        } else {
          this.message405(res)
        }
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["formUser"].validate(valid => {
        if (valid) {
          if (this.formUser.id !== undefined) {
            editBuyer(this.formUser).then(res => {
              if (res.data.code == 200) {
                this.$notify({
                  title: '修改成功',
                  type: 'success',
                  duration: 1000
                });
                this.open = false;
                this.getList();
              } else {
                this.message405(res)
              }
            });
          } else {
            addBuyer(this.formUser).then(res => {
              if (res.data.code == 200) {
                this.$notify({
                  title: '新增成功',
                  type: 'success',
                  duration: 1000
                });
                this.open = false;
                this.getList();
              } else {
                this.message405(res)
              }
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    removeUserForTicket(row) {
      this.$confirm('是否確認删除購票者姓名為"' + row.name + '"的資料項目?', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delBuyer({
          id: row.id
        }).then(() => {
          this.getList();
          this.$notify({
            title: '删除成功',
            type: 'success',
            duration: 1000
          });
        })
      })
    },
    // 支付押金
    payDeposit(ticketId) {
      payTicketDeposit({
        ticketId,
        payType: 3,//银联扫码
      }).then(res => {
        if (res.data.code == 200) {
          this.$notify({
            title: '押金下單成功，快掃碼支付吧~',
            type: 'success',
            duration: 3000
          });

          this.isShowQrcode(res.data.data.url)//生成二维码
          this.getScanCodeStatus(res.data.data.order_rn)//每秒刷新订单状态
        } else {
          this.message405(res)
        }
      });
    },
    // 显示二维码
    isShowQrcode(payUrl) {
      this.isPaySuccess = false
      this.isPopupPay = true
      this.$nextTick(() => {
        this.$refs.qrcode.innerHTML = "";
        this.qrcodeWechat("qrcode", 300, 300, payUrl, "canvas");
      });
    },
    // 每秒刷新扫码状态
    getScanCodeStatus(orderRn) {
      if (this.isPaySuccess || !this.isPopupPay) {
        return;
      }
      getYaOrderStatus({
        orderRn
      }).then(res => {
        if (res.data.code == 200) {
          this.cancelPopupPay()
          this.gueryUserTicketList()
          this.$notify({
            title: '押金支付成功~',
            type: 'success',
            duration: 3000
          });
        } else {
          if (this.statusTimeout == null && this.isPopupPay) {
            this.scanCodeStatusSetTimeout(orderRn)
          }
        }
      });
    },
    // 每秒刷新一下
    scanCodeStatusSetTimeout(orderRn) {
      this.statusTimeout = setInterval(() => {
        this.getScanCodeStatus(orderRn)
      }, 2000)
    },
    // 关闭支付二维码弹窗
    cancelPopupPay() {
      if (this.statusTimeout) {
        clearInterval(this.statusTimeout)
        this.statusTimeout = null
      }
      this.isPopupPay = false
      this.isPaySuccess = false
    },
  },
};
</script>
<style lang="less">
.add-user-dialog {
  .el-dialog {
    width: 500px;
    max-width: 90%;
  }
}
</style>
<style lang="less" scoped>
.el-dropdown-menu__item {
  color: #000;
  font-size: 12px !important;
}

.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #000000;
  color: #ffffff;
}

.el-button--primary {
  background-color: #000;
  border-color: #000;
}

.el-button--primary.is-plain {
  background-color: #fff;
  border-color: #000;
  color: #000;
}

.el-button--primary:hover,
.el-button--primary:focus {
  background: rgba(0, 0, 0, .8);
  border-color: rgba(0, 0, 0, .8);
}

.el-button--primary.is-plain:hover,
.el-button--primary.is-plain:focus {
  background: #fff;
  border-color: rgba(0, 0, 0, .8);
  color: rgba(0, 0, 0, .5);
}

.dialog-back {
  position: absolute;
  right: 30px;
  top: 20px;
}

.title {
  width: 70%;
  height: auto;
  margin-bottom: 10px;
}

.question-body {
  width: 100%;
  height: 100vh;
  position: relative;

  .ticket-video {
    width: 100%;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
  }

  .question-box {
    width: 450px;
    height: 550px;
    position: fixed;
    right: 80px;
    top: 0;
    bottom: 0;
    margin: auto;
    border-radius: 15px;
    padding: 15px 30px 30px;
    background-color: #fff;
    box-sizing: border-box;


    .flex {
      display: flex;
    }

    .tabs-box {
      .el-button {
        width: 50%;
        margin-left: 0;
      }

      .el-button:first-child {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }

      .el-button:last-child {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }

    .verifice-input {
      width: 230px;
    }

    .verifice-btn {
      margin-top: 21px;
      width: 150px;
      height: 40px;

      .el-button {
        width: 100%;
        height: 40px;
        padding: 0;
        background-color: #68DDF4;
        border: none;
        color: #fff;

        .verifice-cn {
          font-size: 11px;
        }
      }
    }
  }

  .ticket-list {
    width: 100%;
    height: 300px;
    margin: 20px 0;
    overflow-y: auto;
    scrollbar-width: none;
    /* Firefox 兼容 */

    .nodata-tip {
      height: 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      color: #606266;
      font-size: 12px;
    }

    .ticket-content {
      .ticket-box {
        width: 100%;
        margin-bottom: 10px;
        border: 1px solid #000;
        padding: 10px;
        box-sizing: border-box;


        .ticket-right {
          width: 100%;
          display: flex;
          font-size: 12px;

          .image {
            width: 100px;
            height: 100%;
            object-fit: cover;
            border-radius: 5px;
            margin-right: 10px;
          }

          .title {
            width: 100%;
          }

          .time {
            font-size: 10px;
            color: #828282;
            margin-bottom: 5px;
          }

        }

        .action-btn {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 10px;

          .el-dropdown-link {
            cursor: pointer;
            color: #000;
            font-size: 12px;
          }

          .el-icon-arrow-down {
            font-size: 12px;
          }

          .el-button {
            width: 80px;
            font-size: 8px;
            padding: 5px 0;
          }
        }
      }
    }
  }

  /* Chrome/Safari/Edge 隐藏滚动条 */
  .ticket-list::-webkit-scrollbar {
    display: none;
    /* 完全隐藏滚动条 */
  }

  .dialog-footer {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .el-button {
      width: 48%;

      .en,
      .cn {
        font-size: 12px;
      }
    }
  }

  .popup-content {
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, .5);
    z-index: 100;
    position: fixed;
    left: 0;
    top: 0;
    color: #000;

    .popup-box {
      width: 500px;
      height: 500px;
      max-width: 90%;
      background-color: #fff;
      border-radius: 15px;
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      padding: 10px;
      box-sizing: border-box;

      .add-user {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 150px;
        height: 25px;
        box-shadow: 0 0 10px 1px #BA74F7;
        border-radius: 20px;
        font-size: 12px;
        cursor: pointer;
        margin: auto;
        color: #BA74F7;

        .el-icon-circle-plus-outline {
          font-size: 15px;
        }
      }

    }

    .qrcode-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 30px;

      .title {
        width: 70%;
        height: auto;
      }

      .qrcode-text {
        text-align: center;
        font-size: 12px;
      }
    }

    .popup-user {
      overflow-y: auto;
    }

    .user-list {
      .user-singel {
        background-color: rgba(168, 168, 168, 0.1);
        margin-top: 10px;
        border-radius: 5px;
        padding: 10px;

        .user-info {
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 10px;

          .user-tag {
            margin-right: 5px;
          }
        }

        .action-btn {
          display: flex;
          justify-content: flex-end;

          .btn {
            font-size: 12px;
            border: 1px solid #000;
            padding: 5px 10px;
            border-radius: 5px;
            margin-left: 5px;
            cursor: pointer;
          }
        }
      }
    }
  }

  .popup-pay-content {
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, .5);
    z-index: 100;
    position: fixed;
    left: 0;
    top: 0;
    color: #000;

    .popup-box {
      width: 300px;
      height: 300px;
      max-width: 90%;
      background-color: #fff;
      border-radius: 15px;
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

/* 响应式设计：在屏幕宽度小于 480px 时调整字体和布局 */
@media (max-width: 780px) {

  .question-body {
    .dialog-back {
      right: 20px;
      top: 20px;
    }

    .question-box {
      width: 330px;
      height: 480px;
      position: fixed;
      left: 0;
      right: 0;
      padding: 20px;
      box-sizing: border-box;

      .verifice-input {
        width: 200px;
      }

      .verifice-btn {
        width: 80px;
      }

      .ticket-list {
        height: 250px !important;

        .image {
          min-width: 80px;
        }
      }
    }
  }
}
</style>
<style>
@media (max-width: 780px) {
  .el-message-box {
    width: 300px !important;
  }
}
</style>